<template>
  <el-table
    ref="xTable"
    class="x-table"
    :data="data"
    :border="border"
    style="width: 100%"
    @row-click="onRowClick"
    @cell-click="onCellClick"
    :cell-class-name="activeCell"
    :show-summary="showSummary"
    :summary-method="summaryMethod"
  >
    <el-table-column width="47px" align="center" v-if="actionCol" class-name="no-focus">
      <template slot-scope="{row,$index}">
        <el-dropdown trigger="click" placement="bottom" @command="onInsert($event,$index)">
          <el-button type="text" style="font-size: 14px;" icon="el-icon-s-tools"></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="up">向上插入一行</el-dropdown-item>
            <el-dropdown-item command="down">向下插入一行</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </el-table-column>
    <slot name="tb-column"></slot>
  </el-table>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    //是否显示插入行按钮
    actionCol: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: true,
    },
    //用于判断是否空行的方法
    //空行焦点会跳到新行第一个可输入的单元格，非空行则会跳到下方单元格
    //返回是否新行 true/false
    filterFunc: {
      type: Function,
      default: undefined,
    },
    showSummary: {
      type: Boolean,
      default: false,
    },
    summaryMethod: {
      type: Function,
      default: undefined,
    },
  },
  data() {
    return {
      codes: [
        "Numpad8",
        "Numpad6",
        "Numpad2",
        "Numpad4",
        "Enter",
        "NumpadEnter",
      ],
      keys: ["ArrowUp", "ArrowRight", "ArrowDown", "ArrowLeft", "Enter"],
      wrapper: null,
      current: { row: null, col: null },
    };
  },
  mounted() {
    var _this = this;
    var xTable = _this.$refs.xTable;
    // console.log("xTable", xTable);
    this.wrapper = Array(...xTable.$el.children).find(
      (x) => x.className.indexOf("el-table__body-wrapper") != -1
    );

    xTable.$el.onkeyup = function (e) {
      // if (e.ctrlKey) console.log("onkeyup", e);

      if (_this.keys.indexOf(e.key) != -1 && _this.codes.indexOf(e.code) != -1)
        _this.setMove(e);
    };

    //监听单元格获得焦点事件
    xTable.$el.addEventListener("focusin", function (e) {
      // console.log("focusin 事件", e);
      //设置当前选中的单元格
      _this.setCurrent(e);
    });

    document.onkeyup = function (e) {
      if (e.key != "Enter") return;
      var picker = document.querySelector(".el-date-picker");
      // console.log("picker", document.querySelectorAll(".el-date-picker"));
      // return;
      if (picker && picker.offsetParent != null) {
        const td = xTable.$el.querySelector(".active-cell");
        const tr = td.parentNode;

        // console.log("移动到下一格", [td, tr]);

        const tds = Array(...tr.cells).filter(
          (x) => x.className.indexOf("no-focus") == -1
        );

        //找出位于当前节点之后的所有可输入节点
        const next_tds = tds.filter((x) => x.cellIndex > td.cellIndex);

        // console.log("enter", next_tds);

        //数量是否大于0，大于0取第一个
        if (next_tds.length > 0) {
          const cell = next_tds[0].children[0];
          _this.MoveAction(cell);
        } else {
          console.log("没有可输入节点");
        }
      }
    };
  },
  methods: {
    onInsert(type, index) {
      this.$emit("on-insert", { type, index });
    },
    activeCell({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === this.current.row && columnIndex === this.current.col) {
        return "active-cell";
      }
      return "";
    },
    onRowClick(row, column, event) {
      this.$emit("row-click", row);
    },
    onCellClick(row, column, cell, event) {
      // if (cell.className.indexOf("no-focus") != -1) return;
      // console.log("单元格点击", event);
      // this.setCurrent(event);
    },
    setCurrent(event) {
      var td = event.path.find((x) => x.localName == "td");
      var tr = event.path.find((x) => x.localName == "tr");

      this.current.row = tr.rowIndex;
      this.current.col = td.cellIndex;
      // console.log(td.children[0].children[0]);
      var e = td.children[0].children[0];
      if (
        e.className.indexOf("el-input") != -1 &&
        e.className.indexOf("el-date-editor") == -1
      ) {
        event.target.select();
      }
    },
    setMove(e) {
      // console.log("有效键位" + e.key + "___" + e.code);
      var _this = this;

      var td = e.path.find((x) => x.localName == "td");
      var tr = e.path.find((x) => x.localName == "tr");

      var node1 = e.target.parentNode;
      try {
        if (node1.__vue__.$parent.hidePicker != undefined) {
          node1.__vue__.$parent.hidePicker();
        }
        var node2 = node1.parentNode;
        if (node2.__vue__ != undefined) node2.__vue__.blur();
      } catch (error) {
        // console.log('try', error)
      }
      // console.log('wrapper', wrapper);

      if (e.code == "Numpad8") {
        if (tr.previousElementSibling == null) {
          var select = e.path.find(
            (x) => !!x.className && x.className.indexOf("el-select") != -1
          );
          if (select) select.click();
          return;
        }
        MoveToTr(tr.previousSibling.children, false);
      }
      if (e.code == "Numpad2") {
        if (tr.nextElementSibling == null) {
          var select = e.path.find(
            (x) => !!x.className && x.className.indexOf("el-select") != -1
          );
          if (select) select.click();
          return;
        }

        if (_this.filterFunc) {
          var res = _this.filterFunc(_this.data[tr.rowIndex + 1]);
          MoveToTr(tr.nextSibling.children, res);
        } else {
          MoveToTr(tr.nextSibling.children, false);
        }
      }
      if (e.code == "Numpad4") {
        //找出所有可输入的节点
        var tds = Array(...tr.cells).filter(
          (x) => x.className.indexOf("no-focus") == -1
        );
        // console.log("tds", tds);

        //找出位于当前节点之前的所有可输入节点
        var prev_tds = tds.filter((x) => x.cellIndex < td.cellIndex);
        // console.log("prev_tds", prev_tds);
        prev_tds = prev_tds.filter((x) => x.firstChild.children.length > 0);
        prev_tds = prev_tds.filter(
          (x) => x.firstChild.children[0].className.indexOf("is-disabled") == -1
        );

        //数量是否大于0，大于0取最后一个
        if (prev_tds.length > 0) {
          var length = prev_tds.length - 1;
          var cell = prev_tds[length].children[0];
          _this.MoveAction(cell);
        } else {
          var now_td = tds.find((x) => x.cellIndex == td.cellIndex);
          var select = now_td.children[0].children[0];
          if (select && select.className.indexOf("el-select") != -1) {
            select.click();
          }
        }

        // if (_this.wrapper.scrollLeft >= 0)
        //   _this.wrapper.scrollLeft -= td.scrollWidth;
      }
      if (e.code == "Numpad6") {
        //找出所有可输入的节点
        var tds = Array(...tr.cells).filter(
          (x) => x.className.indexOf("no-focus") == -1
        );

        //找出位于当前节点之后的所有可输入节点
        var next_tds = tds.filter((x) => x.cellIndex > td.cellIndex);
        next_tds = next_tds.filter((x) => x.firstChild.children.length > 0);
        next_tds = next_tds.filter(
          (x) => x.firstChild.children[0].className.indexOf("is-disabled") == -1
        );

        //数量是否大于0，大于0取第一个
        if (next_tds.length > 0) {
          var cell = next_tds[0].children[0];
          _this.MoveAction(cell);
        } else {
          var now_td = tds.find((x) => x.cellIndex == td.cellIndex);
          var select = now_td.children[0].children[0];
          if (select && select.className.indexOf("el-select") != -1) {
            select.click();
          }
        }

        // if (_this.wrapper.scrollLeft < _this.wrapper.scrollWidth)
        //   _this.wrapper.scrollLeft += td.scrollWidth;
      }
      if (e.key == "Enter") {
        //找出所有可输入的节点
        var tds = Array(...tr.cells).filter(
          (x) => x.className.indexOf("no-focus") == -1
        );

        //找出位于当前节点之后的所有可输入节点
        var next_tds = tds.filter((x) => x.cellIndex > td.cellIndex);
        next_tds = next_tds.filter((x) => x.firstChild.children.length > 0);
        next_tds = next_tds.filter(
          (x) => x.firstChild.children[0].className.indexOf("is-disabled") == -1
        );

        //数量是否大于0，大于0取第一个
        if (next_tds.length > 0) {
          var cell = next_tds[0].children[0];
          _this.MoveAction(cell);
        } else {
          // console.log("没有可输入节点", [tr]);
          if (tr.nextElementSibling != null) {
            MoveToTr(tr.nextSibling.children, true);
          } else {
            //没有下一行的时候，创建新行
            _this.$emit("on-insert", {
              type: "down",
              index: _this.data.length - 1,
            });
            var now_td = tds.find((x) => x.cellIndex == td.cellIndex);
            var select = now_td.children[0].children[0];
            if (select && select.className.indexOf("el-select") != -1) {
              select.click();
            }
          }
        }
      }
      //移动到下一行
      //isNew: true/false
      function MoveToTr(tds, isNew) {
        if (isNew) {
          var can_focus_tds = Array(...tds).filter(
            (x) => x.className.indexOf("no-focus") == -1
          );
          if (can_focus_tds.length > 0) {
            var cell = can_focus_tds[0].children[0];
            _this.MoveAction(cell);
          }
        } else {
          var next_tr_td = Array(...tds).find(
            (x) => x.cellIndex == td.cellIndex
          );
          var cell = next_tr_td.children[0];
          _this.MoveAction(cell);
        }
      }
      // if (e.key == "Home") {
      //   _this.wrapper.scrollLeft = 0;
      //   var child = tr.children[0];
      //   var cell = child.children[0];
      //   _this.MoveAction(cell);
      // }
      // if (e.key == "End") {
      //   _this.wrapper.scrollLeft = _this.wrapper.scrollWidth;
      //   var length = tr.children.length;
      //   var child = tr.children[length - 1];
      //   var cell = child.children[0];
      //   _this.MoveAction(cell);
      // }
    },
    //焦点移动
    MoveAction(cell) {
      // console.log('wrapper', wrapper.scrollLeft, wrapper)
      var cell_child = cell.children[0];
      // console.log("cell_child", cell_child);
      if (cell_child == undefined) {
        // cell.setAttribute("tabindex", -1);
        // cell.focus();
        return;
      }
      var class_name = cell_child.className;
      // console.log("class_name", class_name);
      // if (class_name.indexOf("is-disabled") == -1) {
      // }
      if (
        class_name.indexOf("el-input") != -1 &&
        class_name.indexOf("el-date-editor") != -1
      ) {
        // console.log('时间选择器')
        var inner = cell_child.children[0];
        inner.focus();
      } else if (class_name.indexOf("el-select") != -1) {
        // console.log('下拉框');
        cell_child.click();
      } else if (class_name.indexOf("el-input") != -1) {
        // console.log('输入框');
        var inner = cell_child.children[0];
        inner.focus();
        inner.select();
      } else if (class_name.indexOf("complexSelect") != -1) {
        // console.log('复杂选择');
        var span = cell_child.children[0];
        var complexSelect = Array(...span.children).find(
          (x) => x.className.indexOf("el-input") != -1
        );
        // console.log('complex', complexSelect);
        complexSelect.focus();
      } else if (class_name.indexOf("el-checkbox") != -1) {
        cell_child.focus();
      } else {
        // cell.setAttribute("tabindex", -1);
        // cell.focus();
      }
    },
  },
};
</script>
<style lang="scss">
.x-table {
  .el-table__body {
    tbody tr td {
      padding: 0;
      z-index: 1;
      .cell {
        padding: 0;
        .el-input__inner {
          border: none;
        }
      }
      .cell:has(.el-checkbox) {
        text-align: center;
      }
      .cell:not(:has(.el-input)) {
        padding: 0px 15px;
      }
    }
    // tbody tr .no-focus {
    //   padding: 0px 10px;
    // }
  }
}
.active-cell {
  border: 1px solid #009966bf !important;
}
</style>